import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {ServiceCategorySubTypesListFilter} from './ServiceCategorySubTypesListFilter'

const ServiceCategorySubTypesListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddServiceCategorySubTypeModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-servicecategorysubtype-table-toolbar='base'>
      <ServiceCategorySubTypesListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add servicecategorysubtype */}
      <button type='button' className='btn btn-primary' onClick={openAddServiceCategorySubTypeModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='SERVICECATEGORYSUBTYPE.TABLE.CREATESERVICECATEGORYSUBTYPE' defaultMessage={"Create New"} />
      </button>
      {/* end::Add servicecategorysubtype */}
    </div>
  )
}

export {ServiceCategorySubTypesListToolbar}
